import { AuthService } from '~/app/services/auth.service';
import { BusinessService } from '~/app/services/business/business.user.service';
import { BrnMenuTriggerDirective } from '@spartan-ng/ui-menu-brain';
import { BaseSingletonService } from '~/app/services/base.service';
import { Business, BusinessWithRole } from '~/app/services/business/business.types';
import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsightFocusService } from '~/app/services/insight-focus.service';
import { LucideAngularModule } from 'lucide-angular';
// import { LogOut, Briefcase, DollarSign, Settings, Users, Building, Plus } from 'lucide-angular';
import { MenuComponent } from '../../menu/menu.component';
import { HlmIconComponent } from '~/lib/ui/ui-icon-helm/src';
import { HlmMenuItemRadioComponent } from '~/lib/ui/ui-menu-helm/src/lib/hlm-menu-item-radio.component';
import { HlmMenuComponent, HlmMenuGroupComponent, HlmMenuItemDirective, HlmMenuItemRadioDirective, HlmMenuItemSubIndicatorComponent, HlmMenuLabelComponent, HlmMenuSeparatorComponent, HlmMenuShortcutComponent, HlmSubMenuComponent } from '~/lib/ui/ui-menu-helm/src';
import { Router } from '@angular/router';


@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [
    CommonModule,
    MenuComponent,
    BrnMenuTriggerDirective,
    HlmMenuComponent,
    HlmSubMenuComponent,
    HlmMenuItemDirective,
    HlmMenuItemSubIndicatorComponent,
    HlmMenuLabelComponent,
    HlmMenuShortcutComponent,
    HlmMenuSeparatorComponent,
    HlmMenuGroupComponent,
    HlmMenuItemRadioComponent,
    HlmMenuItemRadioDirective,
    HlmIconComponent,
    LucideAngularModule,
  ],
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SideMenuComponent extends BaseSingletonService {
  selectedMenuItem?: string;
  @Input() menuItems: any[] = [];
  businesses: BusinessWithRole[] = [];
  focusedBusiness: Business | null = null;
  selectedBusinessId: string | null = null;
  protected readonly authState$;

  constructor(
    private readonly _authService: AuthService,
    private readonly _router: Router,
    private readonly _businessService: BusinessService,
    private _insightFocusService: InsightFocusService,
  ) {
    super();  // Since this class extends BaseService, super() is constructor of BaseService
    this.authState$ = this._authService.authState$;
    this.authState$.subscribe(async (authState) => {
      if (authState.isLoggedIn) {
        this.businesses = await this._businessService.getUserBusinesses();
      }
    });
    this.subscribeToBusinessChanges();
    this.subscribeToInsightChanges();
  }

  ngOnInit(): void {
    this._businessService.focusedBusiness$.subscribe(business => {
      this.focusedBusiness = business;
    });
  }  

  private async subscribeToBusinessChanges() {
    this.subscribe(this._businessService.focusedBusiness$, async (business) => {
      this.focusedBusiness = business;
      if (business) {
        this.selectedBusinessId = business._id;
      } else {
        this.selectedBusinessId = null;
      }
    });
  }

  private subscribeToInsightChanges() {
    this.subscribe(this._insightFocusService.focusedInsightModelChange, async (insightType: string | null) => {
      console.log('Insight focus changed:', insightType); // Add logging
      if (insightType) {
        this.setSelectedMenuItem(insightType);
      } else {
        this.setSelectedMenuItem();
      }
    });
  }

  setSelectedMenuItem(menuItem?: string) {
    this.selectedMenuItem = menuItem;
    this.menuItems.forEach(item => item.isActive = item.label === menuItem);
  }

  selectBusiness(businessId: string) {
    this.selectedBusinessId = businessId;
    const selectedBusiness = this.businesses.find(business => business._id === businessId);
    if (selectedBusiness) {
      this._businessService.setFocusedBusiness(selectedBusiness);
    }
  }

  login() {
    this._router.navigate(['/login']);
  }

  async logout() {
    await this._authService.logout();
  }

  navigateTo(route: string) {
    this._router.navigate([route]);
  }

  async createNewBusiness() {
    this._router.navigate(['/onboarding']);
  }

  async initSelectedBusiness() {
    const businesses = await this._businessService.getUserBusinesses();
    if (businesses.length > 0) {
      this.selectBusiness(businesses[0]._id);
    }
  }
}
